export default __webpack_public_path__ + "static/media/magic-mouse.f8ccce24.png";